module.exports = __webpack_public_path__ + "img/mudim.20e0383c.jpg";